import { Routes } from '@angular/router';
import { loginRoutes } from '@softapps/allgemein/login';
import { settingsRoutes } from '@softapps/allgemein/utils';
import { passwordRoutes } from '@softapps/allgemein/password';
import { moduleRoutes } from '@softapps/allgemein/modules';
import { gesamtabfrageRoutes } from '@softapps/wws/gesamtabfrage';
import { artikelvorratRoutes } from '@softapps/mde/artikelvorrat';
import { artikelInfoRoutes } from '@softapps/wws/artikel-info';
import { bestellerfassungRoutes } from '@softapps/mde/bestellerfassung';
import { bestellvorschlagRoutes } from '@softapps/mde/bestellvorschlag';
import { etikettendruckRoutes } from '@softapps/mde/etikettendruck';
import { materiallieferscheinScanRoutes } from '@softapps/mde/materiallieferschein-scan';
import { retourenRoutes } from '@softapps/mde/retouren';
import { warenverprobungRoutes } from '@softapps/mde/warenverprobung';
import { warenuebernahmeRoutes } from '@softapps/wws/warenuebernahme';
import { eslLinkRoutes } from '@softapps/handel/esl-link';
import { lagerInventurRoutes } from '@softapps/mde/inventur';

export const shellRoutes: Routes = [
  //Allgemein
  ...moduleRoutes,
  ...settingsRoutes,

  ...gesamtabfrageRoutes,

  ...artikelvorratRoutes,
  ...artikelInfoRoutes,
  ...bestellerfassungRoutes,
  ...bestellvorschlagRoutes,
  ...etikettendruckRoutes,
  ...lagerInventurRoutes,
  ...materiallieferscheinScanRoutes,
  ...retourenRoutes,
  ...warenverprobungRoutes,
  ...warenuebernahmeRoutes,
  ...eslLinkRoutes,
];

export const publicRoutes: Routes = [
  ...loginRoutes,
  ...passwordRoutes,
  ...settingsRoutes,
];

/*
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@softapps/core').then((o) => o.ShellComponent),
    children: [
      //Allgemein
      ...moduleRoutes,
      ...settingsRoutes,

      ...gesamtabfrageRoutes,

      ...constructionPartsRoutes,

      ...artikelvorratRoutes,
      ...artikelInfoRoutes,
      ...bestellerfassungRoutes,
      ...bestellvorschlagRoutes,
      ...etikettendruckRoutes,
      ...lagerInventurRoutes,
      ...materiallieferscheinScanRoutes,
      ...retourenRoutes,
      ...warenverprobungRoutes,
      ...warenuebernahmeRoutes,
      ...eslLinkRoutes,
    ],
    canActivate: [AuthenticationGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('@softapps/core').then((o) => o.PublicShellComponent),
    children: [...loginRoutes, ...passwordRoutes, ...settingsRoutes],
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
*/
